import {
    CONTRACT_STATUS_CANCELLED,
    CONTRACT_STATUS_CONCLUDED,
    CONTRACT_STATUS_DRAFT,
    CONTRACT_STATUS_INPROGRESS,
    CONTRACT_STATUS_ONHOLD,
    CONTRACT_STATUS_SUSPENDED
} from "../../../component/Constants";
import { useStatusValuesContract } from "../../../component/useStatusValuesContract";


export const useContractStatuses = () => {

   const {getStatusLabelContract,getStatusColorContract} = useStatusValuesContract()

    return [
        {
            value: CONTRACT_STATUS_DRAFT,
            label: getStatusLabelContract(CONTRACT_STATUS_DRAFT),
            color: getStatusColorContract(CONTRACT_STATUS_DRAFT)
        },
        {
            value: CONTRACT_STATUS_ONHOLD,
            label: getStatusLabelContract(CONTRACT_STATUS_ONHOLD),
            color: getStatusColorContract(CONTRACT_STATUS_ONHOLD)
        },
        {
            value: CONTRACT_STATUS_CANCELLED,
            label: getStatusLabelContract(CONTRACT_STATUS_CANCELLED),
            color: getStatusColorContract(CONTRACT_STATUS_CANCELLED)
        },
        {
            value: CONTRACT_STATUS_CONCLUDED,
            label: getStatusLabelContract(CONTRACT_STATUS_CONCLUDED),
            color: getStatusColorContract(CONTRACT_STATUS_CONCLUDED)
        },
        {
            value: CONTRACT_STATUS_INPROGRESS,
            label: getStatusLabelContract(CONTRACT_STATUS_INPROGRESS),
            color: getStatusColorContract(CONTRACT_STATUS_INPROGRESS)
        },
        {
            value: CONTRACT_STATUS_SUSPENDED,
            label: getStatusLabelContract(CONTRACT_STATUS_SUSPENDED),
            color: getStatusColorContract(CONTRACT_STATUS_SUSPENDED)
        },
    ];

}